import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useToast,
} from "@chakra-ui/react";
import { sendBookingRequestEmail } from "../../../utils/firebase";
import { FormContainer, FormData } from "./FormContainer";

const errors = {
  MENTOR_REQUEST_NOT_SENT:
    "Die Nachricht konnte nicht versendet werden. Bitte versuchen Sie es später nochmal.",
};

export enum BOOKING_TYPE {
  MENTOR_DIRECT_BOOKING = "Mentor kontaktieren",
}

interface IBookingRequestModal {
  type: BOOKING_TYPE;
  emailPreHeader: string;
  buttonText: string;
  subject: string;
  isOpen: boolean;
  onClose: () => void;
  mentorId: string;
}

export const MentorRequestModal: React.FC<IBookingRequestModal> = ({
  subject,
  emailPreHeader,
  buttonText,
  type,
  isOpen,
  onClose,
  mentorId,
}) => {
  const toast = useToast();
  const [error, setError] = useState<string | null>(null);
  const initialRef = React.useRef<HTMLInputElement | null>(null);

  const onSetBookingRequestError = () => {
    setError(errors.MENTOR_REQUEST_NOT_SENT);
  };

  const onSendBookingRequestEmail = async (formValues: FormData) => {
    try {
      const requestData = {
        subject: `[mentorlab]: ${subject}`,
        preHeader: emailPreHeader,
        message: formValues.text,
        mentorId: formValues.mentorId,
        email: formValues.email,
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        company: formValues.company,
      };
      // TODO: add new mail fct
      return await sendBookingRequestEmail(requestData);
    } catch (error) {
      console.log(`Sending mentor request failed with error: ${error}`);
      onSetBookingRequestError();
    }
  };

  return (
    <Modal
      initialFocusRef={initialRef}
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
    >
      <ModalOverlay />
      <ModalContent p={4}>
        <ModalHeader>{type}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormContainer
            buttonText={buttonText}
            onSendBookingRequest={onSendBookingRequestEmail}
            onCloseModal={onClose}
            initialFormValue={{ mentorId }}
            setError={onSetBookingRequestError}
          />
          {error &&
            toast({
              title:
                "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später nochmal",
              status: "error",
              isClosable: true,
            })}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
